"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.afterDay = exports.inSevenDays = exports.isTommorow = exports.isToday = exports.incrementDate = void 0;
const compareDates = (date1, date2) => {
    return (date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate());
};
const incrementDate = (date, dayToAdd) => {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate() + dayToAdd);
};
exports.incrementDate = incrementDate;
const daysBetween = (date1, date2) => {
    const diff = Math.abs(date1.getTime() - date2.getTime());
    return diff / (1000 * 60 * 60 * 24);
};
const isToday = (date) => {
    const today = new Date();
    return compareDates(today, date);
};
exports.isToday = isToday;
const isTommorow = (date) => {
    const today = (0, exports.incrementDate)(new Date(), 1);
    return compareDates(today, date);
};
exports.isTommorow = isTommorow;
const inSevenDays = (date) => {
    return daysBetween(date, new Date()) < 7;
};
exports.inSevenDays = inSevenDays;
const afterDay = (date) => {
    return new Date().getTime() > date.getTime();
};
exports.afterDay = afterDay;
//# sourceMappingURL=date.js.map